import { Certificate } from './certificate';

export const Certificates: Certificate[] = [
  { id: 10, name: 'Seminar1', room: 12 },
  { id: 11, name: 'Seminar2', room: 14 },
  { id: 12, name: 'Seminar 3', room: 15 },
  { id: 14, name: 'Seminar 4', room: 16},
  { id: 15, name: 'Workshop1', room: 17 },
  { id: 16, name: 'Worksho2', room: 18 },
  { id: 17, name: 'Workshop3', room: 19 },
  { id: 18, name: 'Workshop4', room: 20 },
];